import * as React from "react";

const { Component } = React;

import { createOrSaveIntegration } from "./IntegrationStore";
import { alert } from "../general/alertStore.js";
import IntegrationTrigger from "./IntegrationTrigger";
import axios from "../general/HttpClient";
import { GetContext, UnsubscribeContext } from "../general/ApplicationContext";
import { Input, FormGroup, Label } from "../components/Modal";

class EntegyIntegrationConfig {
    url?: string;
    apiKey?: string;
    apiSecret?: string;
    projectID?: string;

    constructor(config) {
        let _config = config || {};
        this.url = _config.url || "https://core.entegy.com.au";
        this.apiKey = _config.apiKey || "";
        this.apiSecret = _config.apiSecret || "";
        this.projectID = _config.projectID || "";
    }
}

class EntegyIntegration {
    config: EntegyIntegrationConfig;
    name: string;
    integrationDirection: number;
    integrationType: number;
    integrationId: number;
    triggerId: string;
    triggerLastRun: string;
    triggerEnabled: boolean;
    organizationId: string;

    constructor(integration: any = {}) {
        this.name = integration.name || "";
        this.integrationDirection = integration.integrationDirection;
        this.integrationType = integration.integrationType;
        this.integrationId = integration.integrationId;
        this.triggerId = integration.triggerId;
        this.triggerLastRun = integration.triggerLastRun;
        this.triggerEnabled = integration.triggerEnabled;
        this.organizationId = integration.organizationId;

        this.config = new EntegyIntegrationConfig(integration.config);
    }
}

interface EntegyState {
    profiles: Array<EntegyIntegration>;
    users: any;
    selectedProfile: EntegyIntegration;
    selectedProfileId: string;
    syncResult: any;
}

interface EntegyProps {
    organization: string;
}

let contextSubscriptionId = "";

export default class ExportEntegyUsers extends Component<EntegyProps, EntegyState> {
    constructor(props) {
        super(props);

        this.state = {
            profiles: [],
            users: [],
            selectedProfile: new EntegyIntegration(),
            selectedProfileId: "",
            syncResult: undefined,
        };
    }

    saveProfile = () => {
        if (this.state.selectedProfile.name) {
            this.setState(
                (prevState) => {
                    prevState.selectedProfile.integrationDirection = 1; //Out
                    prevState.selectedProfile.integrationType = 5; //Entegy
                    prevState.selectedProfile.organizationId = this.props.organization;

                    return prevState;
                },
                () => {
                    createOrSaveIntegration(this.state.selectedProfile).then(() => {
                        this.getProfiles();
                    });
                }
            );
        }
    };

    syncUsers = () => {
        axios.post(`/api/Integrations/${this.state.selectedProfileId}/ExportUsersToEntegy`, this.state.selectedProfile.config).then(
            (response) => {
                alert({
                    type: "alert-success",
                    text: `Users synced successfully`,
                });
            },
            (response) => {
                this.setState({ syncResult: response.data });
            }
        );
    };

    componentDidMount() {
        contextSubscriptionId = GetContext((context) => {
            this.getProfiles();
        });
    }

    componentWillUnmount() {
        UnsubscribeContext(contextSubscriptionId);
    }

    getProfiles = () => {
        axios
            .get(`/api/Integrations/Types/5`) //Entegy
            .then((response) => {
                this.setState({ profiles: response.data, selectedProfile: new EntegyIntegration(), selectedProfileId: "" });
            });
    };

    handleProfileChange = (e) => {
        let id = e.target.value;
        this.setState((prevState) => ({ selectedProfileId: id, selectedProfile: new EntegyIntegration(prevState.profiles.filter((profile) => profile.integrationId == id)[0]) }));
    };

    handleNameChange = (e) => {
        let name = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.name = name;
            return prevState;
        });
    };

    handleEntegyUrlChange = (e) => {
        let url = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.url = url;
            return prevState;
        });
    };

    handleApiKeyChange = (e) => {
        let apiKey = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.apiKey = apiKey;
            return prevState;
        });
    };

    handleApiSecretChange = (e) => {
        let apiSecret = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.apiSecret = apiSecret;
            return prevState;
        });
    };

    handleprojectIDChange = (e) => {
        let projectID = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.projectID = projectID;
            return prevState;
        });
    };

    render() {
        return (
            <div className="space-y-6">
                <h3 className="text-2xl font-semibold text-gray-900">Entegy Users</h3>

                <div className="space-y-6">
                    <FormGroup>
                        <Label htmlFor="profile">Profile</Label>
                        <Input type="select" id="profile" onChange={this.handleProfileChange} value={this.state.selectedProfileId}>
                            <option>Please Select</option>
                            {this.state.profiles.map((profile) => (
                                <option key={profile.integrationId} value={profile.integrationId}>
                                    {profile.name}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>

                    {this.state.selectedProfileId && (
                        <div>
                            <IntegrationTrigger integration={this.state.selectedProfile}></IntegrationTrigger>
                        </div>
                    )}

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <FormGroup>
                            <Label htmlFor="profileName">Profile Name</Label>
                            <Input type="text" id="profileName" value={this.state.selectedProfile.name} onChange={this.handleNameChange} />
                        </FormGroup>

                        {!this.state.selectedProfileId && (
                            <div className="flex items-end justify-end">
                                <button className="px-4 py-2 bg-green-600 text-white font-medium rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors" type="button" onClick={this.saveProfile}>
                                    Create Profile
                                </button>
                            </div>
                        )}
                    </div>

                    {this.state.selectedProfileId && (
                        <div className="space-y-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <FormGroup>
                                    <Label htmlFor="entegyUrl">Entegy URL</Label>
                                    <Input type="text" id="entegyUrl" value={this.state.selectedProfile.config.url} onChange={this.handleEntegyUrlChange} />
                                </FormGroup>

                                <FormGroup>
                                    <Label htmlFor="apiKey">API Key</Label>
                                    <Input type="text" id="apiKey" value={this.state.selectedProfile.config.apiKey} onChange={this.handleApiKeyChange} />
                                </FormGroup>

                                <FormGroup>
                                    <Label htmlFor="apiSecret">API Secret</Label>
                                    <Input type="text" id="apiSecret" value={this.state.selectedProfile.config.apiSecret} onChange={this.handleApiSecretChange} />
                                </FormGroup>

                                <FormGroup>
                                    <Label htmlFor="projectID">Project ID</Label>
                                    <Input type="text" id="projectID" value={this.state.selectedProfile.config.projectID} onChange={this.handleprojectIDChange} />
                                </FormGroup>

                                <div className="flex items-end justify-end md:col-span-2">
                                    <button className="px-4 py-2 bg-green-600 text-white font-medium rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors" type="button" onClick={this.saveProfile}>
                                        Save Profile
                                    </button>
                                </div>
                            </div>

                            <div className="flex justify-end">
                                <button className="px-4 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors" type="button" onClick={this.syncUsers}>
                                    Sync
                                </button>
                            </div>

                            {this.state.syncResult && !this.state.syncResult.success && (
                                <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
                                    <div className="text-red-800 font-medium">Errors</div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
